import React from 'react';
import {SharedSingleEvent} from '@/app/events/shared-single-event';

// Import styles
import './styles/toutix-whitelabel.css';

interface SingleEventPageContainerProps {
  className?: string;
  eventId?: string;
  previewToken?: string | null;
  isAffiliate?: boolean;
  ref?: string | null;
}

export const SingleEventPageContainer: React.FC<SingleEventPageContainerProps> = ({ 
  className = '',
  eventId,
  previewToken,
  isAffiliate,
  ref
}) => {
  return (
    <div className={`toutix-whitelabel ${className}`}>
      <SharedSingleEvent 
        eventId={eventId}
        previewToken={previewToken}
        isAffiliate={isAffiliate}
        ref={ref}
      />
    </div>
  );
};

